import React from 'react';

interface Props {
  children: React.ReactNode;
}

const ProgressBarHideOnSticky = ({ children }: Props) => {
  return (
    <div className="progressbar__hideonsticky">
      <div className="progressbar__hideonsticky-inner">{children}</div>
    </div>
  );
};

export default ProgressBarHideOnSticky;
